/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages

        var nextCounter = 1;
        var multiFive = 0;
        $(".carousel-control-next").click(function () {
          nextCounter++;
          if (SAPO.CPU !== undefined) {
            if (nextCounter === 3) {
              SAPO.CPU.refresh('#mrec > div');
            }
            if (nextCounter > 3) {
              multiFive++;
              if (multiFive % 5 === 0) {
                SAPO.CPU.refresh('#mrec > div');
              }
            }
          }
        });

        function mrecPos() {
          if ($(".single-carousel").length) {
            var galH = $('.single-carousel').offset();

            var pubH = $('#mrec').offset();

            var headerH = $('.header').height();
            var infoH = $('.info-block').height();
            var difH = headerH + infoH;

            $(window).scroll(function () {
              if ($(window).scrollTop() > pubH.top) {
                if ($(window).scrollTop() > galH.top) {
                  $('#mrec').css({
                    position: 'absolute',
                    top: galH.top - difH
                  });
                } else {
                  $('#mrec').css({
                    position: 'fixed',
                    top: 80
                  });
                }
              } else {
                $('#mrec').css({
                  position: 'relative',
                  top: 0
                });
              }
            });
          }
        }

        if (window.canRunAds === undefined) {
          // adblocker detected, show fallback
        } else {

          //$('.pub-home-videos').empty();
          //$('.pub-home-videos').html('<div data-pub="appNexus" data-pub-siteid="IMPALA_Para_Eles" data-pub-pageid="ARTICLE_ROS" data-pub-formatid="MPU"></div>');

          //$('.pub-home').empty();
          //$('.pub-home').html('<div data-pub="appNexus" data-pub-siteid="IMPALA_Para_Eles" data-pub-pageid="ARTICLE_ROS" data-pub-formatid="MPU"></div>');
        }

        var videoIframe = $('.post .entry-content p > iframe');

        $(videoIframe).each(function () {
          $(this).parent().find('br').remove();
          $(this).parent().before(this);
          $(this).wrap("<p class='embed-responsive embed-responsive-16by9'></p>");
          $(this).addClass('embed-responsive-item');
        });

        $('.post .entry-content .wp-embedded-content').parent('p').removeClass('embed-responsive embed-responsive-16by9');


        // var fbModal = function () {
        //     window.Cookies.create('visited', 1, 1)
        // };

        window.Cookies = {
          create: function (name, value, days) {
            value = encodeURIComponent(value);
            if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              var expires = "; expires=" + date.toGMTString();
            } else
              var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/";

          },
          read: function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
              if (c.indexOf(nameEQ) == 0) {
                var value = c.substring(nameEQ.length, c.length);
                value = decodeURIComponent(value);
                return value;
              }
            }
            return null;
          },
          erase: function (name) {
            Cookies.create(name, "", -1);
          }
        };

        function isForShow() {
          var result = false;
          var datafbpop = {};
          if (Cookies.read("fb-pop") === null) {
            var iniDate = new Date();
            iniDate.setDate(iniDate.getDate() - 2);
            datafbpop = {'count': 0, 'date': iniDate};
            Cookies.create("fb-pop", JSON.stringify(datafbpop), 999999);
          }
          datafbpop = JSON.parse(Cookies.read("fb-pop"));
          var cookiesDate = new Date(datafbpop.date);
          cookiesDate.setDate(
            (datafbpop.count < 3 ? cookiesDate.getDate() + 1 : cookiesDate.getDate() + 15)
          );
          var datenow = new Date();

          if (cookiesDate < datenow) {
            $('#fb-modal').modal({
              show: true
            });
            Cookies.create('wBounce', true, 1);
            var newDatafbpop = {'count': datafbpop.count + 1, 'date': new Date()};
            Cookies.create("fb-pop", JSON.stringify(newDatafbpop), 999999);
          }
          return result;
        }

        $("#fb-modal").on("hidden.bs.modal", function () {
          Cookies.create('wBounce', false, 1);
        });

        //isForShow(); // para aparecer o pop up do facebook

        $(".open-zoom").colorbox({rel: 'open-zoom', maxWidth: '95%', maxHeight: '95%'});

        //$(".twentytwenty-container[data-orientation!='vertical']").twentytwenty({default_offset_pct: 0.7});

        $(".carousel").swiperight(function () {
          $(this).carousel('prev');
        });
        $(".carousel").swipeleft(function () {
          $(this).carousel('next');
        });

        $('#cboxNext').click(function () {
          sendTraker();
        });
        $('#cboxPrevious').click(function () {
          sendTraker();
        });


        $('.single-carousel').bind('slid.bs.carousel', function (e) {
          sendTraker();

          //init ->
          var $this = $(this);
          $this.children('.control').show();
          if ($('.single-carousel .carousel-item:first').hasClass('active')) {
            $this.children('.prev.control').hide();
          } else if ($('.single-carousel .carousel-item:last').hasClass('active')) {
            $('.control.next ').click(function (event) {
              event.preventDefault();

              var URL = $('.ver-mais .row .col-sm-6 a').first().attr("href");
              window.location.href = URL;

            });
          }

        });


        $(".ajax-loader").hide();
        $(".load-more").hide();
        var counter = 1;

        window.load = true;

        function read_more() {
          $('.single .ver-mais').click(function () {
            $('.read-more-active').css('max-height', '100%');
            $('.ReadMoreContainer').css('display', 'none');
            mrecPos();
          });
        }

        $('.ver-mais:not(.listagem)').live("click", function () {
          sendTraker();
        });

        read_more();

        function load_more() {
          if (window.load) {
            window.load = false;
            $ajaxSpinner = $(".load-content-" + counter + " .ajax-loader");
            $ajaxSpinner.fadeIn();
            $el = $(".load-more-" + counter);

            var URL = $el.attr('href');

            window.history.pushState("", "", URL);

            URL = URL + ' .main-content';

            $(".load-content-" + counter).load(URL, function () {
              document.title = $(".load-content-" + counter + " h2.title").text();


              $(".load-content-" + counter).animate({opacity: "1"});
              $(".destaques-category-" + counter).addClass("open");

              $ajaxSpinner.fadeOut();
              counter++;
              read_more();
              window.load = true;
            });
          }
        }

        function fixedHeader() {
          if ($(window).width() <= 992) {
            $('header').addClass('fixed');
            $('#menu').addClass('fixed');
          } else {
            $('header').removeClass('fixed');
            $('#menu').removeClass('fixed');
          }
        }

        fixedHeader();

        $(window).scroll(function () {
          if ($(window).width() > 992) {
            if ($(window).scrollTop() >= 50) {
              $('header').addClass('fixed');
              $('#menu').addClass('fixed');
            } else {
              $('header').removeClass('fixed');
              $('#menu').removeClass('fixed');
            }
          }

          if ($(window).scrollTop() + $(window).height() === $(document).height()) {
            load_more();
          }
        });


        var rt = ($(window).width() - ($('#search-btn').offset().left + $('#search-btn').outerWidth()));

        if (rt < 335) rt = 335;

        $(window).resize(function () {
          fixedHeader();

          rt = ($(window).width() - ($('#search-btn').offset().left + $('#search-btn').outerWidth()));

          if (rt < 335) rt = 335;
        });

        $('.show-menu').click(function () {
          var cardH = $('#myNav .menu-list').height() / 2;
          $('#myNav .menu-list').css('top', '50vh').css('top', '-=' + cardH + 'px');

          if ($(window).width() > 575) {
            $('#myNav').css('width', rt);
          } else {
            $('#myNav').css('width', '100vw');
            $(document.body).addClass('overflow-hidden');
          }

          $('.close-block').css('display', 'flex').hide().fadeIn();
        });

        $('#closeNav').click(function () {
          $('#myNav').css('width', '0');
          $('.close-block').fadeOut(300);
          $(document.body).removeClass('overflow-hidden');
        });

        $('#search-btn').click(function () {
          $('#menu').css('top', '0');
          $(document.body).addClass('overflow-hidden');
          $('#myNav').css('width', '0');
          $('.close-block').fadeOut(300);
          $('#search').focus();
        });

        $('#close-search').click(function () {
          $('#menu').css('top', '-100vh');
          $(document.body).removeClass('overflow-hidden');
        });


        // $('.show-menu').on('click', function (e) {
        //     e.preventDefault();
        //     $("body").addClass("noscroll");
        //     $(".navbar-nav").css("display", "block");
        //     document.getElementById("menu").style.height = "100%";
        // });
        //
        // $('.close-menu ').on('click', function (e) {
        //     e.preventDefault();
        //     document.getElementById("menu").style.height = "0%";
        //     $("body").removeClass("noscroll");
        //     $(".navbar-nav").css("display", "none");
        //     $("#sb-search").css("display", "none");
        // });

        // $("#search-btn").on('click', function () {
        //     $("body").addClass("noscroll");
        //     $("#sb-search").css("display", "block");
        //     document.getElementById("menu").style.height = "100%";
        // });

        Share = {
          facebook: function (purl, ptitle, pimg, text) {
            url = 'http://www.facebook.com/sharer.php?s=100';
            url += '&u=' + encodeURIComponent(purl);
            url += '&p[title]=' + ptitle;
            url += '&p[summary]=' + text;
            url += '&p[url]=' + encodeURIComponent(purl);
            url += '&p[images][0]=' + encodeURIComponent(pimg);
            Share.popup(url);
          },
          twitter: function (purl, ptitle) {
            url = 'http://twitter.com/share?';
            url += 'text=' + encodeURIComponent(ptitle);
            url += '&url=' + encodeURIComponent(purl);
            url += '&counturl=' + encodeURIComponent(purl);
            Share.popup(url);
          },
          pinterest: function (purl, pimg, text) {
            var url = "";
            url = 'https://pinterest.com/pin/create/bookmarklet/?';
            url += 'media=' + encodeURIComponent(pimg);
            url += '&url=' + encodeURIComponent(purl);
            url += 'description=' + encodeURIComponent(text);
            Share.popup(url);

          },

          popup: function (url) {
            window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
          }
        };

        //back to top
        var offset = 300,
          //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
          offset_opacity = 1200,
          //duration of the top scrolling animation (in ms)
          scroll_top_duration = 700,
          //grab the "back to top" link
          $back_to_top = $('.cd-top');

        //hide or show the "back to top" link
        $(window).scroll(function () {
          ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
          if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass('cd-fade-out');
          }
        });

        //smooth scroll to top
        $back_to_top.on('click', function (event) {
          event.preventDefault();
          $('body,html').animate({
              scrollTop: 0,
            }, scroll_top_duration
          );
        });

//search

        /*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 *
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

        /*jshint browser: true, strict: true, undef: true */
        /*global define: false */

        (function (window) {

          'use strict';

          // class helper functions from bonzo https://github.com/ded/bonzo

          function classReg(className) {
            return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
          }

          // classList support for class management
          // altho to be fair, the api sucks because it won't accept multiple classes at once
          var hasClass, addClass, removeClass;

          if ('classList' in document.documentElement) {
            hasClass = function (elem, c) {
              return elem.classList.contains(c);
            };
            addClass = function (elem, c) {
              elem.classList.add(c);
            };
            removeClass = function (elem, c) {
              elem.classList.remove(c);
            };
          } else {
            hasClass = function (elem, c) {
              return classReg(c).test(elem.className);
            };
            addClass = function (elem, c) {
              if (!hasClass(elem, c)) {
                elem.className = elem.className + ' ' + c;
              }
            };
            removeClass = function (elem, c) {
              elem.className = elem.className.replace(classReg(c), ' ');
            };
          }

          function toggleClass(elem, c) {
            var fn = hasClass(elem, c) ? removeClass : addClass;
            fn(elem, c);
          }

          var classie = {
            // full names
            hasClass: hasClass,
            addClass: addClass,
            removeClass: removeClass,
            toggleClass: toggleClass,
            // short names
            has: hasClass,
            add: addClass,
            remove: removeClass,
            toggle: toggleClass
          };

          // transport
          if (typeof define === 'function' && define.amd) {
            // AMD
            define(classie);
          } else {
            // browser global
            window.classie = classie;
          }

        })(window);


        /**
         * uisearch.js v1.0.0
         * http://www.codrops.com
         *
         * Licensed under the MIT license.
         * http://www.opensource.org/licenses/mit-license.php
         *
         * Copyright 2013, Codrops
         * http://www.codrops.com
         */
        (function (window) {

          'use strict';

          // EventListener | @jon_neal | //github.com/jonathantneal/EventListener
          !window.addEventListener && window.Element && (function () {
            function addToPrototype(name, method) {
              Window.prototype[name] = HTMLDocument.prototype[name] = Element.prototype[name] = method;
            }

            var registry = [];

            addToPrototype("addEventListener", function (type, listener) {
              var target = this;

              registry.unshift({
                __listener: function (event) {
                  event.currentTarget = target;
                  event.pageX = event.clientX + document.documentElement.scrollLeft;
                  event.pageY = event.clientY + document.documentElement.scrollTop;
                  event.preventDefault = function () {
                    event.returnValue = false;
                  };
                  event.relatedTarget = event.fromElement || null;
                  event.stopPropagation = function () {
                    event.cancelBubble = true;
                  };
                  event.relatedTarget = event.fromElement || null;
                  event.target = event.srcElement || target;
                  event.timeStamp = +new Date;

                  listener.call(target, event);
                },
                listener: listener,
                target: target,
                type: type
              });

              this.attachEvent("on" + type, registry[0].__listener);
            });

            addToPrototype("removeEventListener", function (type, listener) {
              for (var index = 0, length = registry.length; index < length; ++index) {
                if (registry[index].target == this && registry[index].type == type && registry[index].listener == listener) {
                  return this.detachEvent("on" + type, registry.splice(index, 1)[0].__listener);
                }
              }
            });

            addToPrototype("dispatchEvent", function (eventObject) {
              try {
                return this.fireEvent("on" + eventObject.type, eventObject);
              } catch (error) {
                for (var index = 0, length = registry.length; index < length; ++index) {
                  if (registry[index].target == this && registry[index].type == eventObject.type) {
                    registry[index].call(this, eventObject);
                  }
                }
              }
            });
          })();

          // http://stackoverflow.com/a/11381730/989439
          function mobilecheck() {
            var check = false;
            (function (a) {
              if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
          }

          // http://www.jonathantneal.com/blog/polyfills-and-prototypes/
          !String.prototype.trim && (String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
          });

          // function UISearch(el, options) {
          //     this.el = el;
          //     this.inputEl = el.querySelector('form > input.sb-search-input');
          //     this._initEvents();
          // }

          // UISearch.prototype = {
          //     _initEvents: function () {
          //         var self = this,
          //             initSearchFn = function (ev) {
          //                 ev.stopPropagation();
          //                 // trim its value
          //                 self.inputEl.value = self.inputEl.value.trim();
          //
          //                 if (!classie.has(self.el, 'sb-search-open')) { // open it
          //                     ev.preventDefault();
          //                     self.open();
          //                 }
          //                 else if (classie.has(self.el, 'sb-search-open') && /^\s*$/.test(self.inputEl.value)) { // close it
          //                     ev.preventDefault();
          //                     self.close();
          //                 }
          //             };
          //
          //         this.el.addEventListener('click', initSearchFn);
          //         this.el.addEventListener('touchstart', initSearchFn);
          //         this.inputEl.addEventListener('click', function (ev) {
          //             //ev.stopPropagation();
          //         });
          //         this.inputEl.addEventListener('touchstart', function (ev) {
          //             //ev.stopPropagation();
          //         });
          //     },
          //     open: function () {
          //         var self = this;
          //         classie.add(this.el, 'sb-search-open');
          //         // focus the input
          //         if (!mobilecheck()) {
          //             this.inputEl.focus();
          //         }
          //         // close the search input if body is clicked
          //         var bodyFn = function (ev) {
          //             self.close();
          //             this.removeEventListener('click', bodyFn);
          //             this.removeEventListener('touchstart', bodyFn);
          //         };
          //         document.addEventListener('click', bodyFn);
          //         document.addEventListener('touchstart', bodyFn);
          //     },
          //     close: function () {
          //         this.inputEl.blur();
          //         classie.remove(this.el, 'sb-search-open');
          //     }
          // };

          // add to global namespace
          //window.UISearch = UISearch;

        })(window);

        //new UISearch(document.getElementById('sb-search'));


      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(document).ready(function () {
          if ($('body').hasClass('single-format-gallery')) {
            if (window.canRunAds === undefined) {
              // adblocker detected, show fallback
              $('.main-column').removeClass('col-xl-9');
            }
          }

          // var featuredImgH = function () {
          //     var infoSingleH = $('.info-block').height();
          //     $('.featured-img').css('height', '100vh');
          //     $('.featured-img').css('height', '-=' + infoSingleH + 'px');
          // };
          //
          // if ($(window).width() > 991) {
          //     featuredImgH();
          // }
          //
          // $(window).resize(function () {
          //     featuredImgH();
          // });
        });


      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page


      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

